import { useIntl } from 'react-intl';

interface Props {
  currentOrders: string;
  totalOrders: number;
  isPending?: boolean;
  isCompleted?: boolean;
}

/**
 * Renders the reprocess button label based on pending/completed job state and order count.
 */
export function OrderReprocessButtonLabel({
  currentOrders,
  totalOrders,
  isPending = false,
  isCompleted = false,
}: Props) {
  const { $t } = useIntl();

  const isMultiple = totalOrders > 1;

  if (isPending) {
    if (isMultiple) {
      return (
        <>
          {$t(
            {
              id: 'audit.aod.actions.orderReprocess.processing.multiple',
              defaultMessage: 'Reprocesando órdenes {currentOrders}',
            },
            {
              currentOrders: currentOrders.split(',').join(', '),
            },
          )}
        </>
      );
    }
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.processing',
            defaultMessage: 'Reprocesando orden {orderId}',
          },
          { orderId: currentOrders },
        )}
      </>
    );
  }

  if (isCompleted) {
    if (isMultiple) {
      return (
        <>
          {$t(
            {
              id: 'audit.aod.actions.orderReprocess.completed.multiple',
              defaultMessage: 'Órdenes reprocesadas: {currentOrders}',
            },
            {
              currentOrders,
            },
          )}
        </>
      );
    }
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.completed',
            defaultMessage: 'Orden {orderId} reprocesada',
          },
          { orderId: currentOrders },
        )}
      </>
    );
  }

  if (isMultiple) {
    return (
      <>
        {$t(
          {
            id: 'audit.aod.actions.orderReprocess.multiple',
            defaultMessage: 'Reprocesar {count} órdenes',
          },
          { count: totalOrders },
        )}
      </>
    );
  }

  return (
    <>
      {$t(
        {
          id: 'audit.aod.actions.orderReprocess',
          defaultMessage: 'Reprocesar orden {orderId}',
        },
        { orderId: currentOrders },
      )}
    </>
  );
}
